import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import EmployeeComp from './components/EmployeeComp';
import useEmployee from '@hooks/useEmployee';
import { Employee } from '@models/Models';
import { IoIosAddCircle } from "react-icons/io";
import { useNavigate } from 'react-router-dom';

function Employees() {
    const navi = useNavigate();
    const [employeeList, setEmployeeList] = useState<Employee[]>([]);
    const { getAllEmployees, deleteEmployee } = useEmployee();

    useEffect(() => {
        employeeGetter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const employeeGetter = async ( ) => {
        const employeesResults = await getAllEmployees();

        if(!employeesResults.success) {
            console.error(employeesResults.message);
            alert(employeesResults.message);
            return;
        };

        setEmployeeList(employeesResults.data as Employee[]);
    };

    const handleRemoveEmployee = async(id: string) => {
        await deleteEmployee(id);
        employeeGetter();
    };

    return (
        <Container className='myCont'>
            <Row>
                <Col lg={11}>
                    <h1>Mitarbeiter</h1>
                </Col>
                <Col lg={1} className='d-flex justify-content-end align-items-center'>
                    <IoIosAddCircle
                        color={'#024442'}
                        size={35}
                        onClick={() => navi("/add-mitarbeiter")}
                    />
                </Col>
            </Row>
            
            {employeeList && employeeList.length > 0 &&
                employeeList.map((employee, index) => (
                    <EmployeeComp
                        key={index}
                        item={employee}
                        onEdit={() => navi(`/edit-mitarbeiter/${employee.id}`)}
                        onRemove={handleRemoveEmployee}
                    />
                ))
            }
        </Container>
    )
}

export default Employees
